/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessTokenModel } from '../../models/access-token-model';
import { BomaidRegistrationModel } from '../../models/bomaid-registration-model';

export interface BomaidRegistrationPost$Params {
      body?: BomaidRegistrationModel
}

export function bomaidRegistrationPost(http: HttpClient, rootUrl: string, params?: BomaidRegistrationPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<AccessTokenModel>> {
  const rb = new RequestBuilder(rootUrl, bomaidRegistrationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<AccessTokenModel>;
    })
  );
}

bomaidRegistrationPost.PATH = '/Bomaid/Registration';
